<div class="auth-page-container forgotPassword-wrapper">
  <h2 mat-dialog-title class="join-header px-4 d-flex align-items-center justify-content-between">
    <app-logo-header></app-logo-header>
    <button class="btn float-end mt-2 form-close-btn" (click)="closeDialog()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
          fill="#BAB5B5" />
      </svg>
    </button>
  </h2>
  <hr class="mt-0 mb-2" />

  <mat-dialog-content class="mat-typography join-box-body">
    @if (!showMessageBox) {
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgotForm()">
      <div class="registration-form reset-password-box landing-box">
        <section class="container password-container  py-1">
          <div class="row gap-4">

            <section class="col-md-12 col-sm-12 text-center reset-box">
              <h3 class="text-center">{{'resetPassword' | translate}}</h3>
              <img src="../../../assets/images/oe-logo-full.png" alt="logo">
              <h3 class="text-center fs-6">{{'wantTo' | translate}}</h3>
            </section>

            <section class="col-md-12 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'email' | translate}}</label>
                <section>
                  <div class="input-group"
                    [ngClass]="{'border-danger':  this.sharedService.isFieldInvalid('email', forgotPasswordForm)}">
                    <input type="text" class="form-control" [placeholder]="'typeHere' | translate"
                      formControlName="email" aria-label="forgotEmail" aria-describedby="basic-addon1">
                  </div>
                </section>
              </div>
              <div class="mt-3">
                @if (!isShowLoader) {
                <button type="submit" class="activeBtn fs-6 w-100">{{'submit' | translate}}</button>
                }
                @if (isShowLoader) {
                <button type="button" class="activeBtn fs-6 w-100" disabled>
                   <span class="spinner-border spinner-border-sm mx-2" aria-hidden="true"></span>
                  <span role="status">{{'sending' | translate}}</span>
                </button>
                }
              </div>
            </section>
          </div>
        </section>

        <!-- <div class="social-login text-center">
          <hr class="mt-0 mb-2" />
          <div class="social-icons">
            <section class="d-flex justify-content-center">
              <div id="googleSignInDiv"></div>
            </section>
          </div>
        </div> -->
      </div>

    </form>
    }


    @if (showMessageBox) {
    <section class="row home-box-header reset-box message-box">
      <h4 class="text-center fs-5">
        {{showMessageBox}}
      </h4>
    </section>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <!-- <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button> -->
  </mat-dialog-actions>
</div>